const React = require('react');
const ReactIntl = require('react-intl');
const injectIntl = ReactIntl.injectIntl;
const Footer = require("./Footer");
const AppConstants = require('../../constants/AppConstants')
const UrlUtils = require('../../utils/urlUtils');
const Utils = require('../../utils/Utils');

class FooterMinimal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            footerLoaded: false,
        };
    }

    componentDidMount() {
        const countryCode = UrlUtils.fetchCountryCodeInfo() || AppConstants.DEFAULT_COUNTRY_CODE;

        Utils.loadMinimalFooter(countryCode, (success) => {
            if (success) {
                this.setState({ footerLoaded: true });
            } else {
                console.error('Failed to load the minimal footer.');
            }
        });
    }

    render() {
        if (!this.state.footerLoaded) {
            return(
                <Footer
                {...this.props}
                locale={this.props.localeId}
                onLocalChange={this.props.onLocalChange}
                /> 
            );
        }
        return (
            <div className='footer-container'></div>
        );
    }
}

module.exports = injectIntl(FooterMinimal);
